import gql from 'graphql-tag';

export const getDOPEntries = gql`
  query getDOPEntries($dopGroupId: String, $shiftDate: String) {
    getDOPEntries(dopGroupId: $dopGroupId, shiftDate: $shiftDate) {
      id
      aorId
      aorSubSystemId
      labelId
      entry
      active
      shiftDate
      createdBy
      createdAt
      updater
      updatedAt
      deletedAt
      version
      DOPLabel {
        id
        labelText
        active
      }
      AOR {
        id
        name
      }
      AORSubSystem {
        id
        aorId
        name
        enabled
        deletedAt
      }
    }
  }
`;
